import { useMemo } from 'react';
import { SidebarItem } from '@trukt/ui/Sidebar';
// import { isReportPrivate } from '@trukt/utils/isReportPrivate';
import { PATH_NAMES } from '@components/pages/shared';
import { useReportsQuery } from './useReportsQuery';

export const useReportItems = () => {
  const query = useReportsQuery();

  const items = useMemo(
    () =>
      query.data?.pages.flatMap((page) =>
        page.data.results.map<SidebarItem>((result) => {
          // const isPrivate = isReportPrivate(result.visibility);
          return {
            label: result.name,
            to: `${PATH_NAMES.reports.VIEW}/${result.id}`,
            id: `${PATH_NAMES.reports.VIEW}/${result.id}`,
            // icon: (
            //   <Icon
            //     name={isPrivate ? 'io-md-person' : 'io-md-people'}
            //     title={isPrivate ? 'Private report' : 'Shared report'}
            //   />
            // ),
          };
        }),
      ) || [],
    [query.data, query.data?.pages],
  );

  return { items, query };
};
